import { request } from 'utils/axios';
import getToken from './getToken';

const ENDPOINT = 'orders';

// Shared filter query params for list + count so both stay in sync.
// filter shape: { status: string, amount: [min, max], query: string }
const appendFilterParams = (params, filter = {}) => {
  if (filter.status) {
    params.set('status', filter.status);
  }
  const [min, max] = filter.amount || [0, 0];
  if (min > 0) {
    params.set('totalCost_gte', String(min));
  }
  if (max > 0) {
    params.set('totalCost_lte', String(max));
  }
  if (filter.query) {
    params.set('q', filter.query);
  }
  return params;
};

export const list = (page = 0, pageSize = 10, filter = {}) => {
  const params = new URLSearchParams();
  params.set('_sort', 'updatedAt:desc');
  // pageSize < 0 => let the server return everything (no pagination).
  if (pageSize != null && pageSize >= 0) {
    params.set('_start', String(page * pageSize));
    params.set('_limit', String(pageSize));
  }
  appendFilterParams(params, filter);

  // Send the admin JWT: order list/count/stats are restricted to authenticated
  // users so customer data is not publicly readable.
  return request('get', `${ENDPOINT}?${params.toString()}`, getToken());
};

export const count = (filter = {}) => {
  const params = appendFilterParams(new URLSearchParams(), filter);
  const qs = params.toString();
  return request('get', `${ENDPOINT}/count${qs ? `?${qs}` : ''}`, getToken());
};

export const stats = () => request('get', `${ENDPOINT}/stats`, getToken());

export const get = (id) =>
  request('get', `${ENDPOINT}/${id}`, getToken());

export const edit = (id, data) =>
  request('put', `${ENDPOINT}/${id}`, getToken(), data);

export const remove = (id) =>
  request('delete', `${ENDPOINT}/${id}`, getToken());
